import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import ClosureErrorIcon from 'components/Icons/ClosureErrorIcon';
import { colors } from 'theme';
import { ClosureValidateViolation } from 'types';

const useStyles = makeStyles(theme => ({
  closureError: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'start',
    flexDirection: 'column',
    maxWidth: '50%',
    margin: '0 auto',
  },
  errorBody: {
    display: 'flex',
    margin: '0 10%',
    padding: '50px',
  },
  errorHeader: {
    color: colors.red,
    maxWidth: '686px',
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
  },
  errorIcon: {
    flexShrink: 0,
    marginRight: '26px',
    width: '78px',
    height: '78px',
  },
  errorTitle: {
    fontSize: '18px',
    lineHeight: '21px',
    margin: 'auto 0',
    display: 'flex',
    alignItems: 'center',
    height: '78px',
  },
  errorText: {
    fontSize: '18px',
    lineHeight: '21px',
  },
}));

type ClosureErrorProps = {
  title?: string;
  text?: string;
  errorsList?: ClosureValidateViolation[];
};

const ClosureError: React.FC<ClosureErrorProps> = (props: ClosureErrorProps) => {
  const classes = useStyles();
  const errorsList = props.errorsList;

  return (
    <div className={classes.closureError}>
      <div className={classes.errorHeader}>
        <ClosureErrorIcon className={classes.errorIcon} />
        <Typography className={classes.errorTitle}>{props.title}</Typography>
      </div>
      {(!!props.text || !!props.errorsList) && (
        <div className={classes.errorBody}>
          {!!props.text ? (
            <Typography className={classes.errorText}>{props.text}</Typography>
          ) : (
            !!props.errorsList &&
            props.errorsList.length > 0 && (
              <ul>
                {errorsList?.map((error: ClosureValidateViolation, index: number) => {
                  const key = `${error.message}_${index}`;
                  return <li key={key}>{error.message}</li>;
                })}
              </ul>
            )
          )}
        </div>
      )}
    </div>
  );
};
export default ClosureError;
